// 서치헬퍼 모달 후보를 [조회] 적용 조건으로 거르는 공용 헬퍼 — 후보 API 가 모달 조건을 못 받는 화면(상품관리·권한관리)이 쓴다.
/** 칸 값 → 비교용 문자열(앞뒤 공백·대소문자 무시). 문자열·숫자 외(객체 등)는 빈 값으로 본다. */
const norm = (v: unknown): string => (typeof v === 'string' ? v : typeof v === 'number' ? String(v) : '').trim().toLowerCase()

/**
 * 검색 모달 후보를 [조회] 적용 조건으로 거른다 — 칸마다 부분일치(대소문자 무시), 빈 칸은 조건 없음(모두 비면 전체).
 *  keys = 모달 조회 칸 키 = 후보 표 열 키(생성 뷰의 모달 FilterField·openResetFields 와 같다). 여러 칸은 AND.
 *  조건을 키로 한정하는 이유: 적용 조건에는 뷰가 붙이는 표지(__applied)도 실려 온다.
 */
export const filterHelperRows = <T extends Record<string, unknown>>(rows: T[], applied: Record<string, unknown> | undefined, keys: readonly string[]): T[] => {
  const conds = keys.map((k) => [k, norm(applied?.[k])] as const).filter(([, v]) => v)
  if (!conds.length) return rows
  return rows.filter((r) => conds.every(([k, v]) => norm(r[k]).includes(v)))
}
